<template lang="pug">
  app-plotly(nomeDiv="graficoRelatoriosPeriodo", :dados="graficoDados", :layout="layout")
</template>

<script>
import AppPlotly from '../shared/AppPlotly'
import { colors } from '../../../../utils/constantes'

export default {
  components: {
    AppPlotly
  },

  props: {
    dadosLabels: {
      required: true
    }
  },

  data () {
    return {
      dados: [],
      layout: {
        showlegend: true,
        height: 350,
        legend: {
          orientation: 'v'
        },
        xaxis: {
          showticklabels: false,
          title: 'Período',
          range: [-0.5, 9.5],
          type: 'category'
        },
        yaxis: {
          title: 'Quantidade de cadastros de REURB'
        },
        margin: {
          b: 45,
          l: 45,
          t: 45
        }
      },
      colors,
      loading: true
    }
  },

  watch: {
    titulo: function (val, oldVal) { // eslint-disable-line
      this.layout.xaxis.title = val
    }
  },

  computed: {

    dadosWithColor () {
      return this.dadosLabels.map((dado, index) => ({
        ...dado,
        color: this.colors[index]
      }))
    },

    graficoDados () {
      if (_.isEmpty(this.dadosLabels)) {  // eslint-disable-line
        return []
      }

      const graficoDados = []

      for (let index = 0; index < this.dadosWithColor.length; index++) {
        graficoDados.push({
          x: [this.dadosWithColor[index].label],
          y: [this.dadosWithColor[index].valor],
          type: 'bar',
          text: this.dadosWithColor[index].valor,
          textposition: 'auto',
          textfont: {
            size: 14
          },
          name: this.dadosWithColor[index].label,
          hoverinfo: 'none',
          marker: { color: [this.dadosWithColor[index].color] }
        })
      }

      return graficoDados
    },

    hasData () {
      return !_.isEmpty(this.dados)  // eslint-disable-line
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/relatorios_reurb/components/graficos/GraficoRelatoriosPeriodo.vue